import { Group } from './Group';
export default Object.assign('Form', { Group });